const CompanyData = [
    {
        name: "Disney",
        marketCap: 261700000000,
        shareValue: 145.15,
        exchange: "NYSE",
        industry: "media"
    },
    {
        name: "Apple",
        marketCap: 1380000000000,
        shareValue: 314.38,
        exchange: "NASDAQ",
        industry: "technology"
    },
    {
        name: "Lufthansa",
        marketCap: 7290000000,
        shareValue: 15.35,
        exchange: "ETR",
        industry: "transport"
    },
    {
        name: "Netflix",
        marketCap: 150280000000,
        shareValue: 342.99,
        exchange: "NASDAQ",
        industry: "media"
    },
    {
        name: "Tesla",
        marketCap: 95560000000,
        shareValue: 529.79,
        exchange: "NASDAQ",
        industry: "transport"
    },
    {
        name: "Microsoft",
        marketCap: 1250000000000,
        shareValue: 163.60,
        exchange: "NASDAQ",
        industry: "technology"
    },
    {
        name: "SAP",
        marketCap: 150980000000,
        shareValue: 122.90,
        exchange: "ETR",
        industry: "technology"
    },
];
export default CompanyData;
